import {ChangeDetectorRef, Component} from "@angular/core";
import {Page} from "../../../../orchestration/page";
import {NavigationService} from "../../../../orchestration/navigation.service";
import {NotificationService} from "../../../../notification/notification.service";
import {IdentityModel} from "../../../../identity/identity.model";
import {OrderModel} from "../../../order.model";
import {OrderingContextModel} from "../../../../ordering-context/ordering-context.model";
import {OrchestrationEvents} from "../../../../orchestration/orchestration-events";
import {MenuModel} from "../../../../menu/menu.model";
import {NavigationParams} from "../../../../orchestration/navigation-params";
import {OrderCompositeItem, OrderPlgItem} from "../../../order";
import {MenuPlgSellableData, MenuItemData} from "../../../../menu/menu-entity.model";

@Component({
    selector: "woa-order-item-plg-edit-page",
    templateUrl: "./order-item-plg-edit-page.component.html",
    providers: [{provide: Page, useExisting: OrderItemPlgEditPageComponent}]
})
export class OrderItemPlgEditPageComponent extends Page {
    OrchestrationEvents = OrchestrationEvents;

    public orderItem: OrderCompositeItem;
    public currentItem: OrderPlgItem;
    public plgItem: OrderPlgItem;
    public menuItem: MenuItemData;
    public anyHaveImages: boolean;
    public availablePlgSellables: MenuPlgSellableData[];
    private readonly originalSelectedSellableId: number;

    constructor(navigationParams: NavigationParams,
                public orderingContextModel: OrderingContextModel,
                public navigationService: NavigationService,
                private orderModel: OrderModel,
                private identityModel: IdentityModel,
                private menuModel: MenuModel,
                private changeDetectorRef: ChangeDetectorRef,
                private notificationService: NotificationService) {
        super();
        this.orderItem = navigationParams.get("orderItem");
        this.currentItem = navigationParams.get("currentItem");
        this.menuItem = navigationParams.get("menuItem");
        this.plgItem = new OrderPlgItem(this.currentItem.parent, this.currentItem.name, this.currentItem.sellable, this.currentItem.quantity, this.currentItem.plg);
        this.availablePlgSellables = this.plgItem.plg.sellableLines.filter((plgSellable) => this.menuModel.plgItemIsAvailable(plgSellable.menuItem, this.menuItem, this.orderItem.selectedFilterTags));
        this.anyHaveImages = this.availablePlgSellables.some((plgSellable: MenuPlgSellableData) => !!this.menuModel.getStandardItemImage(plgSellable.menuItem));
        if (this.currentItem && this.currentItem.sellable) {
            this.originalSelectedSellableId = this.currentItem.sellable.sellableId;
        }
    }

    isPlgSellableSelected(plgSellable: MenuPlgSellableData): boolean {
        return (this.plgItem.sellable && plgSellable.sellable && plgSellable.sellable.sellableId === this.plgItem.sellable.sellableId);
    }

    showPlgSellableUnavailable(plgSellable: MenuPlgSellableData): boolean {
        return this.plgSellableAtLimit(plgSellable) && !this.isPlgSellableSelected(plgSellable);
    }

    plgSellableAtLimit(plgSellable: MenuPlgSellableData): boolean {
        if (plgSellable.sellable.sellableId === this.originalSelectedSellableId) {
            return false;
        }
        return this.orderModel.sellableAtLimit(plgSellable.menuItem ? plgSellable.menuItem.sellable.sellableId : plgSellable.sellable.sellableId, this.orderItem.quantity, this.orderItem.sellableQtyOrdered(this.orderItem.quantity, plgSellable.sellable.sellableId));
    }

    async selectPlgSellable(plgSellable: MenuPlgSellableData): Promise<void> {
        if (this.isPlgSellableSelected(plgSellable)) {
            return;
        }

        if (this.plgSellableAtLimit(plgSellable)) {
            if (this.menuModel.itemOutOfStock(plgSellable.menuItem)) {
                // noinspection ES6MissingAwait
                this.notificationService.displayAlert(null, "woa.message.order.productOutOfStock", {item: plgSellable.menuItem.name});
            } else {
                // noinspection ES6MissingAwait
                this.notificationService.displayAlert(null, "woa.message.order.productLimitReached", {item: plgSellable.menuItem.name});
            }
            return;
        }

        if (this.orderingContextModel.currentStore.minimumAge && plgSellable.sellable.applyMinimumAge && !await this.identityModel.verifyAge()) {
            return;
        }

        this.plgItem.selectSellable(plgSellable.sellable, this.orderItem);
        this.changeDetectorRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-item/order-item-options-panel/order-item-plg-edit-page/order-item-plg-edit-page.component.ts